import React from 'react';
import { AppBreadcrumb, AppContainer, AppTypography } from '@/components/atoms';
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';

type AdminClinicsListTemplateProps = {
  breadcrumbItems: BreadcrumbItemType[];
  /** Page heading. Defaults to 治療院 when omitted. */
  title?: string;
  filter: React.ReactNode;
  /** RA2: 新規 button right after the form, before the table */
  betweenFilterAndTable?: React.ReactNode;
  table: React.ReactNode;
};

const AdminClinicsListTemplate: React.FC<AdminClinicsListTemplateProps> = ({
  breadcrumbItems,
  title = '治療院',
  filter,
  betweenFilterAndTable,
  table,
}) => {
  return (
    <AppContainer>
      <AppBreadcrumb items={breadcrumbItems} />
      <AppTypography.H4 className="my-4 !font-normal">{title}</AppTypography.H4>
      {filter}
      {betweenFilterAndTable}
      {table}
    </AppContainer>
  );
};

export default AdminClinicsListTemplate;
